import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRevisionCurrentPut = {
    path: "/revision/current",
    method: RouteHttpVerb.PUT
};
